import { memo } from "react";
import Box from "@mui/material/Box";
import { WebRoutes } from "consts/enpoints/web";
import {
    BusinessInformationLabel,
    DirectorsAndShareholdersLabel,
    FinancialInformationLabel,
    PaymentMethodsLabel,
    RiskAndComplianceLabel,
    MarketingWebsiteAndSupportLabel,
    UploadDocumentsLabel
} from "./steps";
import {
    Stats,
    OnboardingLayout,
    OnboardingGettingStarted
} from "../common";
import { useOnboardingApplication } from "./hooks";
import OnboardingInitialStepRedirect from "./OnboardingInitialStepRedirect";

const OnboardingHighRiskGettingStarted = () => {
    const {
        isApplicationStarted,
        getApplicationModel
    } = useOnboardingApplication();

    if (isApplicationStarted()) {
        return (
            <OnboardingInitialStepRedirect
                prefix="step/"
            />
        );
    }

    const labelSx = {
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        px: 2,
        py: 1
    };

    return (
        <OnboardingLayout
            slotProps={{
                container: {
                    sx: {
                        maxWidth: 1020
                    }
                }
            }}
        >
            <OnboardingGettingStarted
                slots={{
                    stats: (
                        <Stats
                            route={WebRoutes.Onboarding.HighRiskMerchant}
                            getApplicationModel={getApplicationModel}
                        />
                    )
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        gap: .5
                    }}
                >
                    <Box
                        sx={{
                            display: 'grid',
                            alignSelf: 'flex-start',
                            gap: 1
                        }}
                    >
                        {[
                            BusinessInformationLabel,
                            DirectorsAndShareholdersLabel,
                            FinancialInformationLabel,
                            PaymentMethodsLabel,
                            RiskAndComplianceLabel,
                            MarketingWebsiteAndSupportLabel
                        ].map((Component, index) => (
                            <Component
                                key={index}
                                sx={labelSx}
                            />
                        ))}
                    </Box>
                    <UploadDocumentsLabel
                        sx={labelSx}
                    />
                </Box>
            </OnboardingGettingStarted>
        </OnboardingLayout>
    );
};

export default memo(OnboardingHighRiskGettingStarted);
